// Canonical list of headline app features. Shown consistently across the
// paywall, the logged-out home, and the sign-in page so the messaging never
// drifts between screens.
export const APP_FEATURES = [
  'Create your society & invite your friends',
  'Unlimited rounds & tournaments',
  'Live leaderboards, insights & analytics',
  'Big Screen Leaderboard Presentation Mode',
];
